import { ICartData, IFrontConfiguratorProduct, IFrontConfiguratorImages } from '@features/cart/typescript';
const productFrontAdapter = (configuratorData: IFrontConfiguratorProduct, images: IFrontConfiguratorImages): [ICartData[], boolean] => {
  const products = configuratorData.data.cartData.products;
  let isQuantityChanged = false;
  if (images.dedicated) {
    products.map(product => {
      return {
        ...product,
        image: images.dedicated
      };
    });
  }
  return [products, isQuantityChanged];
};
export default productFrontAdapter;